import React from 'react'
import video from '../photo_video/offline.mp4'

function Offline() {
    return (
        <div className='OfflineCub' id='Offlineclub'>
            <div className='d-flex justify-content-center mt-4'>
                <div className='mb-5 position-relative'><h2 className='pageHeader'>Offline Club</h2></div>
            </div>
            <div className='offlineVideo p-4'>
                <video muted controls autoPlay loop style={{ width: '100%', borderRadius: '20px' }}>
                    <source src={video} type="video/mp4" /> 
                </video>
            </div>
            <div className='container d-flex justify-content-center flex-column align-items-center mt-2 mb-4'>
                <p className='borderLeft mt-3'>In the journey towards achieving a healthier lifestyle, the guidance and expertise of a professional coach can be a game-changer. A skilled coach offers personalized advice, motivation, and accountability, helping you navigate the complexities of diet planning and make sustainable, positive changes to your eating habits. </p>
                {/* <p className='borderLeft mt-3'>One of the key benefits of working with a coach is receiving expert nutritional advice. Coaches possess in-depth knowledge of nutrient requirements, food composition, and meal planning. They can guide you in selecting the right balance of macronutrients and micronutrients, ensuring your diet supports your goals. </p> */}
            </div>
        </div>
    )
}

export default Offline
